'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { Button } from '@/shared/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle } from '@/shared/components/ui/drawer';
import { useAppContext } from '@/shared/contexts/app';
import { useMediaQuery } from '@/shared/hooks/use-media-query';
import { PricingItem } from '@/shared/types/blocks/pricing';
import { PaymentProviders } from './payment-providers';
export function PaymentModal(t0) {
  const $ = _c(53);
  const {
    isLoading,
    pricingItem,
    onCheckout
  } = t0;
  const t = useTranslations("common.payment");
  const {
    isShowPaymentModal,
    setIsShowPaymentModal
  } = useAppContext();
  const {
    configs
  } = useAppContext();
  const pathname = usePathname();
  const callbackURL = pathname || "/";
  const isDesktop = useMediaQuery("(min-width: 768px)");
  if (isDesktop) {
    let t1;
    if ($[0] !== t) {
      t1 = t("choose_payment_method");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <DialogTitle>{t1}</DialogTitle>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t) {
      t3 = t("choose_payment_method_description");
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t3) {
      t4 = <DialogDescription>{t3}</DialogDescription>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
      t5 = <DialogHeader>{t2}{t4}</DialogHeader>;
      $[8] = t2;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== callbackURL || $[12] !== configs || $[13] !== isLoading || $[14] !== onCheckout || $[15] !== pricingItem) {
      t6 = <PaymentProviders callbackUrl={callbackURL} configs={configs} loading={isLoading} setLoading={_temp} pricingItem={pricingItem} onCheckout={onCheckout} />;
      $[11] = callbackURL;
      $[12] = configs;
      $[13] = isLoading;
      $[14] = onCheckout;
      $[15] = pricingItem;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    let t7;
    if ($[17] !== t5 || $[18] !== t6) {
      t7 = <DialogContent className="sm:max-w-[425px]">{t5}{t6}</DialogContent>;
      $[17] = t5;
      $[18] = t6;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    let t8;
    if ($[20] !== isShowPaymentModal || $[21] !== setIsShowPaymentModal || $[22] !== t7) {
      t8 = <Dialog open={isShowPaymentModal} onOpenChange={setIsShowPaymentModal}>{t7}</Dialog>;
      $[20] = isShowPaymentModal;
      $[21] = setIsShowPaymentModal;
      $[22] = t7;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    return t8;
  }
  let t1;
  if ($[24] !== t) {
    t1 = t("choose_payment_method");
    $[24] = t;
    $[25] = t1;
  } else {
    t1 = $[25];
  }
  let t2;
  if ($[26] !== t1) {
    t2 = <DrawerTitle>{t1}</DrawerTitle>;
    $[26] = t1;
    $[27] = t2;
  } else {
    t2 = $[27];
  }
  let t3;
  if ($[28] !== t) {
    t3 = t("choose_payment_method_description");
    $[28] = t;
    $[29] = t3;
  } else {
    t3 = $[29];
  }
  let t4;
  if ($[30] !== t3) {
    t4 = <DrawerDescription>{t3}</DrawerDescription>;
    $[30] = t3;
    $[31] = t4;
  } else {
    t4 = $[31];
  }
  let t5;
  if ($[32] !== t2 || $[33] !== t4) {
    t5 = <DrawerHeader className="text-left">{t2}{t4}</DrawerHeader>;
    $[32] = t2;
    $[33] = t4;
    $[34] = t5;
  } else {
    t5 = $[34];
  }
  let t6;
  if ($[35] !== callbackURL || $[36] !== configs || $[37] !== isLoading || $[38] !== onCheckout || $[39] !== pricingItem) {
    t6 = <PaymentProviders callbackUrl={callbackURL} configs={configs} loading={isLoading} setLoading={_temp2} pricingItem={pricingItem} onCheckout={onCheckout} className="px-4" />;
    $[35] = callbackURL;
    $[36] = configs;
    $[37] = isLoading;
    $[38] = onCheckout;
    $[39] = pricingItem;
    $[40] = t6;
  } else {
    t6 = $[40];
  }
  let t7;
  if ($[41] !== t) {
    t7 = t("cancel_title");
    $[41] = t;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  let t8;
  if ($[43] !== t7) {
    t8 = <DrawerFooter className="pt-4"><DrawerClose asChild={true}><Button variant="outline">{t7}</Button></DrawerClose></DrawerFooter>;
    $[43] = t7;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  let t9;
  if ($[45] !== t5 || $[46] !== t6 || $[47] !== t8) {
    t9 = <DrawerContent>{t5}{t6}{t8}</DrawerContent>;
    $[45] = t5;
    $[46] = t6;
    $[47] = t8;
    $[48] = t9;
  } else {
    t9 = $[48];
  }
  let t10;
  if ($[49] !== isShowPaymentModal || $[50] !== setIsShowPaymentModal || $[51] !== t9) {
    t10 = <Drawer open={isShowPaymentModal} onOpenChange={setIsShowPaymentModal}>{t9}</Drawer>;
    $[49] = isShowPaymentModal;
    $[50] = setIsShowPaymentModal;
    $[51] = t9;
    $[52] = t10;
  } else {
    t10 = $[52];
  }
  return t10;
}
function _temp2() {}
function _temp() {}